@if (companyDetails$ | async; as companyDetails) {
  @if (companyBasicComposite$ | async; as companyBasicComposite) {
    <table>
      <tbody>
        <tr>
          <td class="color-blue width-50">{{ 'company.company_card.industry' | translate }}</td>
          <td>
            @for (
              naceCodeComposite of companyBasicComposite.company_nace_code_composites;
              track naceCodeComposite.nace_code.nace_code;
              let isLast = $last
            ) {
              <div>
                {{ naceCodeComposite.nace_code.full_name }} ({{ naceCodeComposite.nace_code.nace_code }})
                @if (
                  naceCodeComposite &&
                  naceCodeComposite.nace_code.nace_code &&
                  naceCodeComposite.nace_code.nace_code.length === 6 &&
                  naceCodeComposite.nace_code.nace_code.indexOf('.') === 3
                ) {
                  <span>
                    (<a
                      [tooltip]="
                        'company.company_card.nace_code_tooltip'
                          | translate: { naceCodeName: naceCodeComposite.nace_code.full_name }
                      "
                      [routerLink]="['/company']"
                      [queryParams]="{
                        'cn_ca.ncs': 'IN:' + naceCodeComposite.nace_code.nace_code,
                        selected_entities: 'c.n,cn_ca.nc_us',
                      }">
                      {{ naceCodeComposite.nace_code.nace_code }} </a
                    >)
                  </span>
                }
              </div>
            }
          </td>
        </tr>
        <tr>
          <td class="color-blue width-50">{{ 'company.company_card.employees' | translate }}</td>
          <td>{{ companyDetails?.employees }}</td>
        </tr>
        <tr>
          <td class="color-blue width-50">{{ 'company.company_card.establishment_date' | translate }}</td>
          <td>{{ companyDetails.establishment_date | date }}</td>
        </tr>
        @if (companyLocation$ | async; as companyLocation) {
          @for (locationType of companyLocation.companyLocationType; track locationType.uuid) {
            <tr>
              <td class="color-blue width-50">
                {{ 'location_type.' + locationType.company_location_type_key | translate }}
              </td>
              <td>
                <div>
                  @if (companyLocation.companyLocationByCompanyLocationType[locationType.uuid]; as location) {
                    @if (location.street_address) {
                      {{ location.street_address }}<br />
                    }
                    {{ location.postal_code }}
                    {{ location.postal_place }}
                    @if (location.country_name) {
                      <br />{{ location.country_name }}
                    }
                  }
                </div>
              </td>
            </tr>
          }
        }
        <tr>
          <td class="color-blue width-50">{{ 'company.company_card.sector' | translate }}</td>
          <td>{{ companyDetails.sector_code_description }} ({{ companyDetails.sector_code }})</td>
        </tr>
      </tbody>
    </table>
  }
}
